import { css } from "@compiled/react";
// @ts-ignore
import { useInView } from "react-intersection-observer";
import { useIntl } from "react-intl";

import {
    JiraOverlayTemplate,
    JPDOverlayTemplate
} from "@/components/signup/layouts/product-overlay-template";
import SiteActivation from "@/components/signup/site-activation";
import { useCohort, useLoggedInHasJira } from "@/components/user-context";

import {
    Headings,
    SitesAreSharedSpacesText,
    WelcomeBackText
} from "../../../components";
import { LoggedInJpdNewUser } from "../free/new-user";

export const LoggedInJpdStandard = () => {
    const { ref } = useInView();
    const cohort = useCohort();
    const isLoggedInHasJira = useLoggedInHasJira();

    if (cohort === "new-user") {
        return <LoggedInJpdNewUser />;
    }

    if (isLoggedInHasJira) {
        return (
            <div ref={ref}>
                <JiraOverlayTemplate size="sm">
                    <Content />
                </JiraOverlayTemplate>
            </div>
        );
    } else {
        return (
            <div ref={ref}>
                <JPDOverlayTemplate size="sm">
                    <Content />
                </JPDOverlayTemplate>
            </div>
        );
    }
};

const Content = () => {
    const { formatMessage } = useIntl();

    return (
        <>
            <Headings
                main={<WelcomeBackText />}
                sub={<SitesAreSharedSpacesText />}
            />
            <SiteActivation />
            <footer css={footerCss}>
                {formatMessage({
                    id: "JiraSoftwarePageTemplate.loggedInHero.recatcha",
                    defaultMessage:
                        "This page is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply."
                })}
            </footer>
        </>
    );
};

const footerCss = css({
    fontSize: 12,
    fontWeight: 400,
    margin: 0,
    fontFamily: "Charlie Text"
});
